import { Transform, Type } from 'class-transformer'
import { IsDate, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator'

export class WhastAppMessageContactsPrfileDto {
  @IsString()
  name!: string
}

export class WhastAppMessageContactsDto {
  @IsString()
  wa_id!: string

  @ValidateNested()
  @Type(() => WhastAppMessageContactsPrfileDto)
  profile!: WhastAppMessageContactsPrfileDto
}

export class WhastAppDto {
  @ValidateNested({ each: true })
  @Type(() => WhastAppMessageContactsDto)
  contacts!: WhastAppMessageContactsDto[]

  @ValidateNested({ each: true })
  @Type(() => WhastAppMessageMessagesDto)
  messages!: WhastAppMessageMessagesDto[]

  @IsOptional()
  @Type(() => WhastAppMessageEstatusesDto)
  statuses?: WhastAppMessageEstatusesDto[]
}

export class WhastAppMessageMessagesTextDto {
  @IsString()
  body!: string
}

export class WhastAppMessageMessagesMultimediaBasicoDto {
  @IsString()
  id!: string

  @IsString()
  mime_type!: string

  @IsString()
  sha256!: string

  @IsOptional()
  @IsString()
  link?: string
}

export class WhastAppMessageMessagesMultimediaDto extends WhastAppMessageMessagesMultimediaBasicoDto {
  @IsOptional()
  @IsString()
  file?: string

  @IsOptional()
  @IsString()
  caption?: string
}

export class WhastAppMessageMessagesLocationDto {
  @IsString()
  address!: string
  @IsNumber()
  latitude!: number
  @IsNumber()
  longitude!: number
  @IsString()
  name!: string
  @IsString()
  url!: string
}

export class WhastAppMessageEstatusesDto {
  @IsString()
  id!: string

  @IsString()
  status!: string

  @IsString()
  recipient_id!: string

  @IsString()
  errors!: any

  @IsOptional()
  cuenta?: any
}

export class WhastAppMessageMessagesDto {
  @IsString()
  from!: string

  @IsString()
  id!: string

  @IsDate()
  @Transform(({ value }) => new Date(Number(value) * 1000))
  timestamp!: Date

  @IsOptional()
  @ValidateNested()
  @Type(() => WhastAppMessageMessagesTextDto)
  text?: WhastAppMessageMessagesTextDto

  @IsOptional()
  @ValidateNested()
  @Type(() => WhastAppMessageMessagesMultimediaDto)
  image?: WhastAppMessageMessagesMultimediaDto

  @IsOptional()
  @ValidateNested()
  @Type(() => WhastAppMessageMessagesMultimediaBasicoDto)
  video?: WhastAppMessageMessagesMultimediaBasicoDto

  @IsOptional()
  @ValidateNested()
  @Type(() => WhastAppMessageMessagesMultimediaDto)
  document?: WhastAppMessageMessagesMultimediaDto

  @IsOptional()
  @ValidateNested()
  @Type(() => WhastAppMessageMessagesLocationDto)
  location?: WhastAppMessageMessagesLocationDto

  @IsString()
  type!: string
}
